module.exports = __webpack_public_path__ + "static/carousel-00004-34dcfa85681393a79221fedb4ab4146b.jpg";